import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../../services/auth.js";
import env from "../../../services/env.js";
import security from "../../../services/security.js";

class UberController {
  constructor($http, $state, $stateParams, $location, $timeout, AuthService, $rootScope, $cookies, TrackingService, $window) {
    this.name = "uber";
    this.$http = $http;
    this.$state = $state;
    this.$cookies = $cookies;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$window = $window;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.currentUser = this.$auth.getUserData();
    this.$tracking = TrackingService;
    this.$timeout = $timeout;
    this.remain_loading_count = 0;
    //https://click.appcast.io/track/feeddh?cs=52f
    console.log("what are the params");
    console.dir(this.$location.$$search);
  }

  goToAd() {
    var _this = this;

    if (_this.$location.$$search.url) {
      _this.$timeout(function () {
        _this.remain_loading_count = 1;
        //_this.$rootScope.$emit("SetLoaderDialog", { type : 14, total : 1 });
      });

      _this.$timeout(function () {
        //console.log('going here....');
        //console.dir(_this.$location.$$search.url);
        _this.$window.location.href = _this.$location.$$search.url;
      }, 500);
    } else {
      console.log("no url");
    }
  }
}

UberController.$inject = ["$http", "$state", "$stateParams", "$location", "$timeout", "auth", "$rootScope", "$cookies", "tracking", "$window"];

export default UberController;



// WEBPACK FOOTER //
// ./client/app/components/deals/uber/uber.controller.js